import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  // const recovery = listeners["recovery"] || function () { };
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const RCSelect = listeners["on-select"] || function () { };

  const toInfo = listeners["toInfo"] || function () { };
  

  // function selectable(row, index) {
  //   if (row.progress !== 100) {
  //     return true
  //   }
  //   return false
  // }

  const Deal = ({ props: { vo } }) => {
    // let flag = vo.row.progress === 100
    let dealConf = [
      ["iconfont icchakanpeixunxiangqing_sel iconfont-adapt", "查看详情", () => toInfo(vo.row), ""],
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const FinishTime = ({ props: { vo } }) => {
    return <span>{vo.row.finishTime || "--"}</span>;
  };

  const Proshow = ({ props: { vo } }) => {
    return <div>{vo.row.progress}%</div>;
  };

  const tableConfig = [
    // {
    //   type: "selection",
    //   label: "main",
    //   selectable: selectable
    // },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "240"
    },
    // {
    //   label: "资源名称",
    //   prop: "bizName",
    //   minWidth: "260"
    // },
    // {
    //   label: "学习进度",
    //   prop: "progress",
    //   minWidth: "80",
    //   showOverflowTooltip: true,
    //   render: vo => <Proshow vo={vo} />
    // },
    // {
    //   label: "完成情况",
    //   prop: "isFinishName",
    //   minWidth: "80",
    //   showOverflowTooltip: true
    // },
    // {
    //   label: "完成时间",
    //   prop: "finishTime",
    //   render: (vo) => <FinishTime vo={vo} />,
    //   minWidth: "120"
    // },
    {
      label: "操作",
      minWidth: "80",
      align: "center",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      talbeCols={tableConfig}
      onSelectionChange={RCSelectionChange}
      onSelect={RCSelect}
    />
  );
};

export default Table;
